import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { Logo, NAV } from "@/components/site/Header";
import { COMPANY, WHATSAPP_URL } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-stone-900 text-stone-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5 space-y-4">
        <Logo light />
        <p className="text-sm leading-relaxed max-w-sm text-stone-400">
          Fresh G9 bananas, red onions and Bhagwa pomegranates from India, packed and shipped by the container on FOB or CIF terms.
        </p>
        <p className="text-xs text-stone-500" data-testid="footer-legal">
          {COMPANY.legalName} · APEDA: {COMPANY.apeda} · IEC: {COMPANY.iec}
        </p>
      </div>
      <div className="md:col-span-3">
        <h4 className="text-white text-sm font-semibold mb-4">Site</h4>
        <ul className="space-y-2 text-sm">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="hover:text-white transition-colors" data-testid={`footer-link-${n.id}`}>{n.label}</Link></li>
          ))}
          <li><Link to="/request-quote" className="hover:text-white transition-colors" data-testid="footer-link-quote">Request a quote</Link></li>
        </ul>
      </div>
      <div className="md:col-span-4 space-y-3 text-sm">
        <h4 className="text-white text-sm font-semibold mb-4">Contact</h4>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white" data-testid="footer-whatsapp">
          <MessageCircle className="h-4 w-4" /> WhatsApp {COMPANY.phoneDisplay}
        </a>
        <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-email">
          <Mail className="h-4 w-4" /> {COMPANY.email}
        </a>
        <p className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /> {COMPANY.address}</p>
      </div>
    </div>
    <div className="border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-24 sm:pb-6 text-xs text-stone-500 flex flex-col md:flex-row gap-2 justify-between">
        <span>© {new Date().getFullYear()} SLN Agro Exports. No prices are published on this site.</span>
        <span>We share bank details only from {COMPANY.email}.</span>
      </div>
    </div>
  </footer>
);
